export function handleDownload(signedUrl: string) {
  const link = document.createElement("a")
  link.href = signedUrl
  link.target = "_blank"
  link.click()
}
